import React from 'react';
import PropTypes from 'prop-types';
import {buildTree} from 'lib/categories';
import Topics from '../components/topics';
import ArticleList from '../components/articles/ArticleList';
import Guides from '../components/guides';
import HelpCta from '../components/help-cta';
import styles from './index.module.scss';

const IndexPage = ({data}) => {
  const {
    allHelpScoutArticle: {edges: articleEdges},
    allHelpScoutCategory: {edges: categoryEdges},
  } = data;

  const articles = articleEdges.map(({node: article}) => article);

  const categoryTree = buildTree(categoryEdges, articleEdges);

  return (
    <div className={styles.Index}>
      <section className={styles.Section}>
        <Topics categories={categoryTree} />
      </section>
      <section className={styles.Section}>
        <ArticleList articles={articles.slice(0, 6)} />
      </section>
      <section className={styles.Section}>
        <Guides />
      </section>
      <section className={styles.Section}>
        <HelpCta />
      </section>
    </div>
  );
};

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

// eslint-disable-next-line
export const query = graphql`
  query IndexPageQuery {
    allHelpScoutCategory(
      sort: {fields: [order]}
      filter: {articleCount: {ne: 0}}
    ) {
      edges {
        node {
          slug
          name
          id
          articleCount
          description
        }
      }
    }
    allHelpScoutArticle {
      edges {
        node {
          id
          name
          slug
          number
          categories
        }
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js